const state = {
    courses: [],
};

const mutations = {
    setCourses(state, value) {
        state.courses = value;
    },
};

const actions = {};

const getters = {
    courses: (state) => state.courses,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
